/**
*   Created by FANGlh on 2019/1/14 15:52.
*   Desc: 学生请假
*/

import React,{Component} from 'react';
import './LeaveAddPage.css';
// import {getOrganization} from "../../utils/api.request";
import {connect} from 'react-redux';
import {getIntValue, getStrValue, isObjEmpty} from "../../utils/common";
import {ORGANIZATION_TEACHER} from "../../utils/api.constants";
import TargetSelect from '../../components/TargetSelect';
import {fetchPost, fetchGet, fetchGetNoSession} from '../../utils/fetchRequest';
import {_baseURL, API} from '../../configs/api.config';
import {Input, Button} from 'antd';
import {Toast, Picker, List, DatePicker} from 'antd-mobile';
import UploadEnclosure from '../../components/UploadEnclosure';
import moment from 'moment';


class LeaveAddPage extends Component{
   constructor(props){
        super(props);
        this.state = {
            targetData: [],
            fileList: [],
            startValue: null,
            endValue: null,
            leaveReason:'',
            votePerson: [],
        }
    }
    componentWillMount() {
        document.title = "学生请假";
    }
    componentDidMount() {
        this.node.scrollIntoView();
        this.getOrganization()
        // console.log('this.props.userInfo.parent',this.props.userInfo)
    }
     render(){
         const targetProps = {
             targetData: this.state.targetData,
             targetValues: this.state.targetList,
             title: '接收人',
             targetCount: this.state.targetCount,
             onTargetChange: this.onTargetChange.bind(this),
             onTargetFocus: this.onTargetFocus.bind(this),
             multiple: false,
         }

         const defaultTargetProps = {
             targetData: [],
             targetValues: this.state.targetList,
             title: '接收人',
             targetCount: this.state.targetCount,
             onTargetChange: this.onTargetChange.bind(this),
             onTargetFocus: this.onTargetFocus.bind(this),
             multiple: false,
         }

        return(
            <div ref={node => this.node = node} style={{fontFamily:"PingFangSC-Regular",letterSpacing:2.5}} className="common-column-layout">
                <div id="padding10">
                    <img class="img-circle" id="margin_top_bottom_15"
                         src={ (
                             this.props.userInfo.parent.student.stuPhoto  == '' ||
                             this.props.userInfo.parent.student.stuPhoto == null ||
                             this.props.userInfo.parent.student.stuPhoto == undefined ||
                             this.props.userInfo.parent.student.stuPhoto.length == 0
                         ) ?  "http://img5.imgtn.bdimg.com/it/u=1494163297,265276102&fm=26&gp=0.jpg"
                             : this.props.userInfo.parent.student.stuPhoto} width={60}
                         height={60}/>
                    <span class="span_17 text_bold " id="row_margin">{this.props.userInfo.user.student.stuName}的请假条</span>
                </div>
                <div className="comhline_sty"></div>

                <DatePicker
                    mode='date'
                    value={this.state.startValue}
                    locale={{
                        okText: '确定',
                        dismissText: '取消'
                    }}
                    onChange={date => this.setState({startValue: date})}>
                    <List.Item arrow="horizontal">请假时间</List.Item>
                </DatePicker>

                <div className="comhline_sty1"></div>

                <DatePicker
                    mode='date'
                    value={this.state.endValue}
                    locale={{
                        okText: '确定',
                        dismissText: '取消'
                    }}
                    onChange={date => this.setState({endValue: date})}>
                    <List.Item arrow="horizontal">结束时间</List.Item>
                </DatePicker>

                <div onChange={this.handelValueCom}>
                    <textarea  ref='leaveReason' className="form-control textarea_sty" rows="4"
                               placeholder="请假原因" maxLength={100}></textarea>
                </div>
                <div className="comhline_sty"></div>
                {/*this.state.targetData.length > 0 ? <TargetSelect {...targetProps}/>
                    : <TargetSelect {...defaultTargetProps}/>*/}
                <div className="item_sty">
                    <div className="left_title">接收人</div>
                    <input ref='gradeClazz' className="text-right right_input" type="text" readonly="readonly" maxLength={20} autoFocus="autoFocus" value={'班主任'}/>
                </div>

                <div className="comhline_sty1"></div>
                    <UploadEnclosure
                        action={API.UPLOAD_FILE}
                        fileList={this.state.fileList}
                        count={9}
                        multiple={true}
                        beforeUpload={this.beforeUpload.bind(this)}
                        handleChange={this.handleChange.bind(this)}
                    />
                <Button className='commonButton' type='primary' style={{margin: '35px',borderRadius:30}}
                        onClick={this.onSubmitClick}>提交</Button>

            </div>
        )
    }
    onSubmitClick = (event) => {
        console.log('state', this.state)
        if (this.isRequesting == true) {
            return
        }
        if (this.state.startValue == null || this.state.startValue == '') {
            Toast.fail('请输入请假开始时间')
            return
        }
        if (this.state.endValue == null || this.state.endValue == '') {
            Toast.fail('请输入请假结束时间！')
            return
        }
        var startT = new Date(this.state.startValue).getTime()
        var endT = new Date(this.state.endValue).getTime()
        // console.log('startT',startT)
        if (startT >= endT) {
            Toast.fail('结束时间必须大于开始时间')
            return
        }
        if (this.state.leaveReason.trim().length == 0) {
            Toast.fail('请填写请假事由')
            return
        }
        if (!isObjEmpty(this.checkNodes)) {
            this.checkNodes.forEach((node, index) => {
                this.state.votePerson.push(node.userId)
            })
        }

        const approveFiles = []
        if (this.state.fileList) {
            this.state.fileList.forEach((value, index) => {
                approveFiles.push(value.picUrl)
            })
        }


        const params = {
            lvTitle: this.props.userInfo.user.student.stuName+"的请假单",
            lvDetails:this.state.leaveReason,
            lvType: 1,
            lvProposer:this.props.userInfo.user.student.stuId,
            lvStatus:1,
            startDate: moment(this.state.startValue).format('YYYY-MM-DD HH:mm:ss'),
            endDate: moment(this.state.endValue).format('YYYY-MM-DD HH:mm:ss'),
            lvRemarks: "备注",
            lvNotifier:JSON.stringify(this.state.votePerson),
            lvFiles:JSON.stringify(approveFiles),
        }
        console.log('param', params)
        this.isRequesting = true
        fetchPost(API.leaveCreate, {
            leaveString:JSON.stringify(params)
        }, {}).then((response) => {
            console.log('response', response)
            this.isRequesting = false
            if (response.success) {
                this.isRequesting = true
                Toast.show(response.data, 1)
                // this.props.history.push("/leaveList/" + this.props.match.params.role)
                // this.props.history.push("/homePage")
                this.backTask = setTimeout(() => {
                    this.props.history.goBack();
                }, 1000)
            }
        }).catch((error) => {
            this.isRequesting = false
            console.log('error', error)
            if (typeof error === 'string') {
                Toast.fail(error, 2)
            } else {
                Toast.fail('请求异常', 2)
            }
        })
    }
    getOrganization = () => {
        Toast.loading('', 0)
        fetchGet(API.getAllTeacher, {
            schoolId: this.props.userInfo.user.schoolId,
        }).then(response => {
            Toast.hide()
            const {targetData} = this.state
            targetData.length = 0
            if (response && response.data) {
                // const schoolArray = response.data.schools
                const teacherArray = response.data

                if (!isObjEmpty(teacherArray)) {
                    const teacherData = []
                    teacherArray.forEach((teacherObj, index) => {
                        if (teacherObj) {
                            teacherData.push({
                                title: getStrValue(teacherObj, 'teacherName'),
                                userId: getIntValue(teacherObj, 'teacherId'),
                                userPhone: getStrValue(teacherObj, 'userPhone'),
                                value: getStrValue(teacherObj, 'teacherName') + `-0-${index}`,
                                key: `0-${index}`,
                            })
                        }
                    })

                    targetData.push({
                        title: `全体老师`,
                        value: `0`,
                        key: `0`,
                        selectable:false,
                        children: teacherData,
                    })
                }
            }
            console.log('targetData', targetData)
            this.setState({
                targetData,
            })
        }).catch(error => {
            Toast.hide()

            if (typeof error === 'string') {
                Toast.fail(error, 2)
            } else {
                Toast.fail('请求异常', 2)
            }
        })
    }
    onTargetFocus = (e) => {
        if (isObjEmpty(this.state.targetData)) {
            this.getOrganization()
        }
    }
    onTargetChange = (value, label, checkNodes, count) => {
        this.checkNodes = checkNodes
        this.setState({
            targetList: value,
            targetCount: count
        });
    }
    handleChange = fileList => {
        if (fileList) {
            this.setState({fileList})
        }
    }
    beforeUpload = (file, fileList) => {

    }
    handelValueCom = (event) => {
        //获取用户名的值
        let leaveReason = this.refs.leaveReason.value;
        //获得内容的值
        this.setState({
            leaveReason: leaveReason,
        })
    }

}

let mapStateToProps = (state) => ({
    userInfo: {...state.redUserInfo}
})

let mapDispatchToProps = (dispatch) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(LeaveAddPage)